import { useContext, useState } from "react";
import { Transition } from "@headlessui/react";
import { AppState } from "App";
import Tour from "reactour";

import MapLeaflet from "components/ui/MapLeaflet";
import Calendar from "components/ui/Calendar";
import Sidebar from "components/ui/Sidebar";
import Feed from "components/ui/Feed";

const HomeView = ({ coords, dates, doTour, icons, latitude, longitude, posts, steps, tagCounts, tags,}) => {

    const [appState, setAppState] = useContext(AppState);

    const [isTourOpen, setIsTourOpen] = useState(doTour);
    const [showMap, setShowMap] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);

    function stopTours() {
        var test = false;
        localStorage.setItem("tour", JSON.stringify(test));
    }

    return (
        <>
            <div className="relative flex flex-col w-full overflow-hidden lg:flex-row lg:space-x-4 lg:justify-center 2xl:space-x-8">
                <div className="w-full lg:w-52">
                    <div className="w-full p-2 mx-auto overflow-x-scroll border-b lg:overflow-visible lg:p-0 bg-itemlight lg:bg-none dark:border-borderdark dark:bg-bgdark lg:border-none lg:rounded-none lg:ml-0">
                        <Sidebar
                            tags={tags}
                            icons={icons}
                            latitude={latitude}
                            longitude={longitude}
                            tagCounts={tagCounts}
                        />
                    </div>
                </div>

                <div className="flex justify-center w-full mt-8 yl:justify-start yl:w-160 2xl:w-190 lg:mt-0">
                    <div
                        className="flex flex-col h-screen overflow-y-scroll w-160 2xl:w-190 yl:mr-0 no-scrollbar::-webkit-scrollbar no-scrollbar"
                        id="first"
                    >
                        <Feed posts={posts} icons={icons} />
                    </div>
                </div>

                <div className="flex-col hidden space-y-4 2xl:space-y-8 yl:flex 2xl:w-144 yl:w-136">
                    <div className="overflow-hidden border rounded-lg bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
                        <div
                            className="p-8 rounded-lg yl:p-4 w-190 yl:w-136 2xl:w-144 h-120 bg-itemlight dark:bg-itemdark"
                            id="third"
                        >
                            <MapLeaflet coords={coords} />
                        </div>
                    </div>

                    <div id="fourth">
                        <Calendar dates={dates} />
                    </div>
                </div>

                {/* <button className="absolute top-0 flex items-center justify-center w-12 h-12 border rounded-lg lg:hidden left-8 bg-item-light dark:bg-itemdark border-borderlight dark:border-borderdark z-1110 text-textlight dark:text-textdark">
                <Earth width="6" height="6" stroke="1"/>
            </button> */}

                <Transition
                    show={showMap}
                    appear={true}
                    enter="transition-opacity duration-75"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="absolute top-0 left-0 z-10 flex items-start justify-center w-full h-screen bg-bglight dark:bg-bgdark lg:left-52 yl:hidden">
                        <div className="z-20 flex justify-center w-full lg:w-5/6 h-5/6 lg:-ml-52">
                            <div className="overflow-hidden border rounded-lg bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark h-144 xl:w-224 w-190">
                                <div className="p-8 rounded-lg h-144 bg-itemlight dark:bg-itemdark">
                                    <MapLeaflet
                                        coords={coords}
                                        setShowMap={setShowMap}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>

                <Transition
                    show={showCalendar}
                    appear={false}
                    enter="transition-opacity duration-75"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="absolute top-0 left-0 flex items-center justify-center w-full h-screen bg-bglight dark:bg-bgdark lg:left-52 z-1100 yl:hidden">
                        <div className="z-20 flex justify-center w-full lg:w-5/6 h-3/6 lg:-ml-52">
                            <Calendar
                                dates={dates}
                                setShowCalendar={setShowCalendar}
                            />
                        </div>
                    </div>
                </Transition>
            </div>
            <Tour
                accentColor="#4A90E2"
                disableDotsNavigation={true}
                onBeforeClose={stopTours}
                rounded={5}
                steps={steps}
                isOpen={isTourOpen}
                onRequestClose={() => setIsTourOpen(false) | stopTours()}
            />
        </>
    );
};

export default HomeView;
